export type Role = {
  keeparea_create: 0 | 1;
  machine_create: 0 | 1;
  update: 0 | 1;
};

export type Menu = {
  active: boolean;
  menu_id: number;
  menu_label: string;
};
